import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { ISummaryResponse, ISummaryResult } from "./index.type";

const useGetPatientReportedOutcomesPdfPage = ({
  billingId,
}: {
  billingId?: string;
}) => {
  const [reportOutcome, setReportOutcome] = React.useState<ISummaryResult>();

  const { loading: getAllReportLoading, makeApiCall } = useApi({
    method: "GET",
    url: `/rtm/summary-page/cron/pdf/patient-reported-outcomes/${billingId}`,
    preAuth: true,
  });

  const getReportOutcome = async () => {
    const { response, error } = await makeApiCall<
      undefined,
      ISummaryResponse
    >();

    if (response?.status === "success") {
      setReportOutcome(response.result);
    }

    if (error) {
      toast.error(error.msg);
      setReportOutcome(undefined);
    }
  };

  React.useEffect(() => {
    getReportOutcome();
  }, []);

  return { getAllReportLoading, reportOutcome };
};

export default useGetPatientReportedOutcomesPdfPage;
